import { render, staticRenderFns } from "./OrderStatusView.vue?vue&type=template&id=fdc157dc&scoped=true&"
import script from "./OrderStatusView.vue?vue&type=script&lang=js&"
export * from "./OrderStatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc157dc",
  null
  
)

export default component.exports